// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast-body {
    padding: 0 !important;
    margin: 0 !important;
}

.Toastify__toast {
    padding: 0 !important;
    min-height: 58px !important;
}

.Toastify__toast-body > div:last-child {
    height: 100% !important
}

.Toastify__close-button {
    padding: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/services/ToastifyService/toastifyStyles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".Toastify__toast-body {\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n}\r\n\r\n.Toastify__toast {\r\n    padding: 0 !important;\r\n    min-height: 58px !important;\r\n}\r\n\r\n.Toastify__toast-body > div:last-child {\r\n    height: 100% !important\r\n}\r\n\r\n.Toastify__close-button {\r\n    padding: 8px !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
